import { FormattedMessage } from 'react-intl';
import { Access, type RoleAccess } from './RoleAccessMatrix.ts';
import type { PropsWithChildren } from 'react';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

export const RoleAccessRights = (props: RoleAccess) => {
    const { access, details } = props;

    let className = 'label label-';
    switch (access) {
        case Access.FULL:
            className += 'success';
            break;
        case Access.RESTRICTED:
            className += 'warning';
            break;
        case Access.NO:
            className += 'danger';
            break;
        default:
            className += 'muted';
            break;
    }

    return (
        <TooltipWrapper details={details}>
            <div className={className}>
                <div className={'display-flex align-items-center gap-5'}>
                    <FormattedMessage id={access} />
                    {details && <span className={'rioglyph rioglyph-info-sign'} />}
                </div>
            </div>
        </TooltipWrapper>
    );
};

const TooltipWrapper = (props: PropsWithChildren<{ details: string | undefined }>) => {
    return props.details ? (
        <OverlayTrigger
            overlay={
                <Tooltip id='tooltip' placement={'top'} allowOnTouch>
                    <div data-testid={'restricted-access-tooltip'}>
                        <FormattedMessage id={props.details} />
                    </div>
                </Tooltip>
            }
        >
            {props.children}
        </OverlayTrigger>
    ) : (
        props.children
    );
};
